@if (loadingGridData()) {
  <aux-table-skeleton />
} @else {
  <div class="mb-[20px] flex justify-end">
    <aux-export-excel-button
      classList="ml-auto"
      [clickFN]="onExport.bind(this)"
      [spinnerSize]="7"
      pendoTag="prepaid-summary-excel-export-button"
    />
  </div>

  <ag-grid-angular
    domLayout="autoHeight"
    class="ag-theme-aux w-full tabular-nums"
    [rowData]="gridData()"
    [gridOptions]="gridOptions"
    (gridReady)="onGridReady($event)"
    auxStickyGrid
  />
}
